export default __webpack_public_path__ + "static/placeholder-845a238311781555c105264634d0e22d.png";